import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp } from "../Reveal";

export const RecrutementTeaser = () => (
  <section data-testid="recrutement-teaser" className="bg-ivoire pb-20 lg:pb-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
      <FadeUp>
        <div className="relative overflow-hidden rounded-[2.5rem] border border-petrol/10 bg-white px-8 py-12 sm:px-14 lg:px-20 lg:py-16">
          <div
            className="absolute -left-20 -bottom-24 w-72 h-72 rounded-t-full bg-sable/50"
            aria-hidden="true"
          />
          <div className="relative flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-16">
            <div className="flex-1">
              <p className="text-xs uppercase tracking-[0.28em] font-semibold text-teal mb-4">
                Recrutement
              </p>
              <h2 className="font-display font-medium text-petrol text-3xl sm:text-4xl leading-tight tracking-tight mb-3">
                Vous êtes commercial ?
              </h2>
              <p className="text-base text-mute leading-relaxed">
                EQUORIS recrute des talents pour accompagner son développement.
              </p>
            </div>
            <Link
              to="/recrutement"
              data-testid="teaser-recrutement-cta"
              className="group shrink-0 inline-flex items-center gap-3 rounded-full border-2 border-petrol text-petrol text-sm font-semibold px-7 py-4 transition-all duration-300 hover:bg-petrol hover:text-ivoire hover:-translate-y-0.5"
            >
              Découvrir nos opportunités
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </FadeUp>
    </div>
  </section>
);
